import axios from "axios";

import { __API_URL__ } from "../SERVER_URL";

const logUserAction = async (actionType, patientId = null, trialName = null) => {
  const token = localStorage.getItem("token");

  const payload = {
    action_type: actionType,
    patient_id: patientId ? patientId : null,
    trial_name: trialName ? trialName : null,
  };

  try {
    await axios.post(`${__API_URL__}/api/appiell/user_actions_logs/`, payload, {
      headers: {
        Authorization: `Token ${token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    console.error("Log creation failed: ", error.response || error);
  }
};

export default logUserAction;
